<template>
  <table-education-level
    :table-headers="tableHeaders"
    :flat-headers="flatHeaders"
  >
    <tr
      class="table__tr"
      v-for="contestGroup in sortedContestGroups"
      :key="contestGroup.id"
    >
      <td
        class="table__td"
        v-for="header in flatHeaders"
        :key="header.value"
      >
        <router-link
          v-if="header.value === 'direction'"
          :to="contestGroupRoute(contestGroup.id)"
        >
          {{ contestGroup[header.value] }}
        </router-link>
        <template v-else>
          {{ contestGroup[header.value] }}
        </template>
      </td>
    </tr>
    <tr class="table__tr table__tr--total">
      <td
        class="table__td"
        v-for="header in flatHeaders"
        :key="header.value"
      >
        <template v-if="header.value === 'direction'">
          Всего
        </template>
        <template v-else>
          {{ total[header.value] }}
        </template>
      </td>
    </tr>
  </table-education-level>
</template>

<script>
import educationLevel from '@main/mixins/education_level'

export default {
  mixins: [educationLevel],
  data: () => ({
    tableHeaders: [
      { title: 'Направление подготовки / специальность', width: '16%', value: 'direction' },
      { title: 'Количество бюджетных мест', width: '9%', value: 'budget_places' },
      { title: 'Количество заявлений на бюджетные места', items: [
        { title: 'По первому приоритету', width: '9%', value: 'budget_first_priority_abiturients' },
        { title: 'По основному высшему приоритету', width: '9%', value: 'budget_highest_priority_abiturients' },
        { title: 'По высшему проходному приоритету', width: '9%', value: 'budget_highest_passing_priority_abiturients' },
        { title: 'Всего', width: '6%', value: 'budget_abiturients' },
      ]},
      { title: 'Количество платных мест', width: '9%', value: 'pay_places' },
      { title: 'Количество заявлений на платные места', items:[
        { title: 'По первому приоритету', width: '9%', value: 'pay_first_priority_abiturients' },
        { title: 'По основному высшему приоритету', width: '9%', value: 'pay_highest_priority_abiturients' },
        { title: 'По высшему проходному приоритету', width: '9%', value: 'pay_highest_passing_priority_abiturients' },
        { title: 'Всего', width: '6%', value: 'pay_abiturients' },
      ]},
    ],
  }),
  computed: {
    sortedContestGroups() {
      return [...this.contest_groups].sort((a, b) =>
        a.direction.localeCompare(b.direction)
      )
    },
  },
}
</script>
